import type { FeatureFlagNames } from 'api/configuration/features/FeatureFlagConfigurationSetting';
import { isLocalDev, isProduction } from 'utils/env';
import { type Nullable, hasValue } from 'utils/values';

/**
 * Note: development only.
 * In `.env.local` file, add "REACT_APP_FEATURE_FLAG=MyAwesomeFeature,AnotherAwesomeFeature".
 */
function getFeatureFlagsOverrides() {
  return isLocalDev ? parseStringToFeatureFlags(process.env.REACT_APP_FEATURE_FLAG) : undefined;
}

export function getFeatureFlagsOverridesFromSessionStorage() {
  const featureFlags = sessionStorage.getItem('featureFlags');
  return !isProduction && hasValue(featureFlags) ? parseStringToFeatureFlags(featureFlags) : undefined;
}

export function setFeatureFlagsOverridesToSessionStorage(featureFlags: Nullable<FeatureFlagNames[]>) {
  if (isProduction) {
    return;
  }

  if (hasValue(featureFlags)) {
    // If featureFlags is an empty array, save an empty string to sessionStorage.
    // So basically it disables all feature flags.
    sessionStorage.setItem('featureFlags', featureFlags.join(','));
  } else {
    sessionStorage.removeItem('featureFlags');
  }
}

/**
 * Note: development only.
 * An array of objects retrieved from the local feature flag overrides.
 */
export const featureFlagsOverridesState = getFeatureFlagsOverrides()?.map((name) => {
  return {
    name,
    enabled: true
  };
});

function parseStringToFeatureFlags(featureFlagsString: Nullable<string>) {
  const featureLags = featureFlagsString?.split(',');

  return hasValue(featureLags) ? (featureLags as FeatureFlagNames[]) : undefined;
}
